<template>
    <span class="d-flex flex-nowrap align-center">
        <router-link v-if="setId" :to="'/set/' + setId" class="del-underline text-black">
            <v-avatar rounded="0" :size="size" class="pointer">
                <v-icon v-if="!avatar" color="#666" icon="mdi:mdi-image-multiple-outline" :size="size * 0.7"></v-icon>
                <v-img v-if="avatar" :src="avatar" cover :height="size"></v-img>
            </v-avatar>
        </router-link>
        <v-avatar v-if="!setId" rounded="0" :size="size">
            <v-icon v-if="!avatar" color="#666" icon="mdi:mdi-image-multiple-outline" :size="size * 0.7"></v-icon>
            <v-img v-if="avatar" :src="avatar" cover :height="size"></v-img>
        </v-avatar>
        <span class="gradient-underline-hover ml-2" v-if="setId">
            <router-link @click.stop :to="'/set/' + setId" class="del-underline gradient-text-hover parent">
                <span class="body-p text-primaryGrey ellipsis-line">{{ name }}</span>
            </router-link>
        </span>
        <span class="gradient-underline-hover ml-2" v-if="!setId">
            <span class="body-p text-primaryGrey ellipsis-line">{{ name }}</span>
        </span>
    </span>
</template>
<script>
export default {
    data(){
        return {
            
        }
    },
    props: {
        setId: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        },
        avatar: {
            type: String,
            default: null
        },
        size: {
            type: Number,
            default: 36
        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {
        
    }
}
</script>
<style scoped>

</style>